export default __webpack_public_path__ + "static/media/sounds/ES_TRO_Read_Answer_Qestions_PU-01.mp3";